export const fullName = (reservation: Reservation) =>
  `${reservation.travelers[0].firstName} ${reservation.travelers[0].lastName}`;
